import { Component, type ErrorInfo, type ReactNode } from "react";
import i18n from "../i18n";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Last-resort catch for render errors so a crash shows a kid-readable message
 * with a reload button instead of a blank white page.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("Unhandled render error:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary">
          <h1>{i18n.t("errors.unexpected")}</h1>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            {i18n.t("errors.reload")}
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
